import React from 'react';
import PropTypes from 'prop-types';

FakeChat.propTypes = {

};

function FakeChat(props) {
    return (
        <div>
            <h3> Fake_Chat giua nhieu thiet bi</h3>
        </div>
    );
}

export default FakeChat;